<div class="layout-footer">
    <div class="p-grid">
        <div class="p-col-12">
            <div class="footer-bottom">
                <h6>Copyright {{currentYear}} Ⓒ TPL</h6>
            </div>
        </div>
    </div>
</div>